import label from "@/lang/StaticLabels.js";

// PHAMSAZ Router  - همساز -----------------------------------------------
let routeItems = {
  path: "PHAMSAZ",
  name: "PHAMSAZ",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PHAMSAZDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PHAMSAZDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.phamsaz,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/Dashboard.vue"),
    },

    // Base Information  -----------------------------------------------
    {
      path: "projectType",
      name: "PHAMSAZProjectType",
      meta: {
        label: label.page.projectType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/projectType"),
    },
    {
      path: "workDescription",
      name: "PHAMSAZWorkDescription",
      meta: {
        label: label.page.workDescription,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/workDescription"),
    },
    {
      path: "generalEstimate",
      name: "PHAMSAZGeneralEstimate",
      meta: {
        label: label.page.generalEstimate,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/generalEstimate"),
    },
    {
      path: "crimesRewardSubject",
      name: "PHAMSAZCrimesRewardSubject",
      meta: {
        label: label.page.crimesRewardSubject,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamsaz/base/crimesRewardSubject"),
    },
    {
      path: "estimationSubject",
      name: "PHAMSAZEstimationSubject",
      meta: {
        label: label.page.estimationSubject,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/estimationSubject"),
    },
    {
      path: "unit",
      name: "PHAMSAZUnit",
      meta: {
        label: label.page.unit,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/unit"),
    },

    {
      path: "setting",
      name: "PHAMSAZSetting",
      meta: {
        label: label.page.settings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/setting"),
    },

    {
      path: "settingMessage",
      name: "PHAMSAZMessageSetting",
      meta: {
        label: label.page.messageSetting,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/base/setting/message"),
    },

    // Operation -----------------------------------------------
    {
      path: "project",
      name: "PHAMSAZProject",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "project/list",
      children: [
        {
          path: "list",
          name: "PHAMSAZProjectList",
          component: () => import("@/views/modules/phamsaz/operation/project"),
          meta: {
            label: label.page.projects,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PHAMSAZAddProject",
          component: () =>
            import("@/views/modules/phamsaz/operation/project/Info"),
          meta: {
            label: label.page.addProject,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMSAZEditProject",
          component: () =>
            import("@/views/modules/phamsaz/operation/project/Info"),
          meta: {
            label: label.page.editProject,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "estimates",
      name: "PHAMSAZEstimates",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "estimates/list",
      children: [
        {
          path: "list",
          name: "PHAMSAZEstimatesList",
          component: () =>
            import("@/views/modules/phamsaz/operation/estimates"),
          meta: {
            label: label.page.estimates,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PHAMSAZAddEstimates",
          component: () =>
            import("@/views/modules/phamsaz/operation/estimates/Info"),
          meta: {
            label: label.page.addEstimates,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMSAZEditEstimates",
          component: () =>
            import("@/views/modules/phamsaz/operation/estimates/Info"),
          meta: {
            label: label.page.editEstimates,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "suite",
      name: "PHAMSAZSuiteList",
      meta: {
        label: label.page.suite,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/operation/suite"),
    },
    {
      path: "blocks",
      name: "PHAMSAZBlock",
      meta: {
        label: label.page.blocks,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/operation/blocks"),
    },
    {
      path: "participation",
      name: "PHAMSAZParticipationList",
      meta: {
        label: label.page.participation,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/participation"),
    },
    {
      path: "announcement",
      name: "PHAMSAZPaymentNotificationList",
      meta: {
        label: label.page.paymentNotification,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/paymentNotification"),
    },

    {
      path: "ranking",
      name: "PHAMSAZRankingList",
      meta: {
        label: label.page.ranking,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/operation/ranking"),
    },
    {
      path: "crimesReward",
      name: "PHAMSAZCrimesRewardList",
      meta: {
        label: label.page.crimesReward,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/operation/crimesReward"),
    },
    {
      path: "transfers",
      name: "PHAMSAZTransfersList",
      meta: {
        label: label.page.transfers,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/operation/transfers"),
    },
    {
      path: "transferVoucherCartable",
      name: "PHAMSAZTransferVoucherCartable",
      meta: {
        label: label.page.transferVoucherCartable,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/transfers/VoucherCartable"),
    },
    {
      path: "memberDeposit",
      name: "PHAMSAZMemberDepositList",
      meta: {
        label: label.page.memberDeposit,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/memberDeposit"),
    },
    {
      path: "memberDepositChequeCartable",
      name: "PHAMSAZMemberDepositChequeCartable",
      meta: {
        label: label.page.memberDepositChequeCartable,
        requiresAuth: true,
        cartableType: "Cheque",
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/memberDeposit/Cartable"),
    },
    {
      path: "memberDepositCashCartable",
      name: "PHAMSAZMemberDepositCashCartable",
      meta: {
        label: label.page.memberDepositCashCartable,
        requiresAuth: true,
        cartableType: "Cash",
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/memberDeposit/Cartable"),
    },
    {
      path: "offset",
      name: "PHAMSAZOffsetList",
      meta: {
        label: label.page.hamsazOffset,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamsaz/operation/offset"),
    },
    {
      path: "offsetVoucherCartable",
      name: "PHAMSAZOffsetVoucherCartable",
      meta: {
        label: label.page.hamsazOffsetVoucherCartable,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamsaz/operation/offset/VoucherCartable"),
    },
    {
      path: "receiveCheque",
      name: "PHAMSAZReceiveChequeList",
      meta: {
        label: label.page.receiveCheque,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbank/operation/receiveCheque"),
    },

    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PHAMSAZReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports/ranking",
      children: [
        {
          path: "rankig",
          name: "PHAMSAZRankingReport",
          component: () => import("@/views/modules/phamsaz/reports/ranking"),
          meta: {
            label: label.page.ranking,
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};

export default routeItems;
